/**
 * @flow
 * @relayHash f8bf4ea6340389ad4ffdf35722b25309
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SongProvider = "SPOTIFY" | "%future added value";
export type CreatePlaylistSongInput = {
  clientMutationId?: ?string,
  playlist_id: string,
  name: string,
  artist?: ?string,
  album?: ?string,
  isrc?: ?string,
  duration_ms?: ?number,
  external_data?: ?string,
  external_source?: ?SongProvider,
  external_id?: ?string,
  position?: ?number,
  song_images?: ?$ReadOnlyArray<?SongImageInput>,
};
export type SongImageInput = {
  url: string,
  width: number,
  height: number,
};
export type UserPlaylist_createPlaylistSongMutationVariables = {|
  input: CreatePlaylistSongInput
|};
export type UserPlaylist_createPlaylistSongMutationResponse = {|
  +createPlaylistSong: ?{|
    +new_playlist_song_edge: ?{|
      +node: ?{|
        +id: string,
        +position: ?number,
        +song: ?{|
          +id: string,
          +isrc: ?string,
          +name: ?string,
          +artist: ?string,
          +album: ?string,
          +song_images: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +url: ?string,
                +width: ?number,
                +height: ?number,
              |}
            |}>
          |},
        |},
      |}
    |},
    +playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type UserPlaylist_createPlaylistSongMutation = {|
  variables: UserPlaylist_createPlaylistSongMutationVariables,
  response: UserPlaylist_createPlaylistSongMutationResponse,
|};
*/


/*
mutation UserPlaylist_createPlaylistSongMutation(
  $input: CreatePlaylistSongInput!
) {
  createPlaylistSong(input: $input) {
    new_playlist_song_edge {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          artist
          album
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
      }
    }
    playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreatePlaylistSongInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreatePlaylistSongInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "position",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "song_images",
  "storageKey": null,
  "args": null,
  "concreteType": "SongImageConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "SongImage",
          "plural": false,
          "selections": [
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            },
            v8,
            v9
          ]
        }
      ]
    }
  ]
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v2,
    v8,
    v9
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserPlaylist_createPlaylistSongMutation",
  "id": null,
  "text": "mutation UserPlaylist_createPlaylistSongMutation(\n  $input: CreatePlaylistSongInput!\n) {\n  createPlaylistSong(input: $input) {\n    new_playlist_song_edge {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          artist\n          album\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n      }\n    }\n    playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserPlaylist_createPlaylistSongMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_playlist_song_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistSongEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistSong",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      v2,
                      v4,
                      v5,
                      v6,
                      v7,
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [
              v11
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserPlaylist_createPlaylistSongMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreatePlaylistSongPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_playlist_song_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "PlaylistSongEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistSong",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "song",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      v4,
                      v5,
                      v6,
                      v7,
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "Playlist",
            "plural": false,
            "selections": [
              v11,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'accade1526db63bddd979d4c64411fe7';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/UserPlaylist_createPlaylistSongMutation.graphql.js